(function () {
  var body = document.body;
  var menuToggle = document.querySelector('[data-menu-toggle]');
  var menuPanel = document.querySelector('[data-menu-panel]');
  var menuClose = document.querySelector('[data-menu-close]');

  function setMenu(open) {
    if (!menuToggle || !menuPanel) return;
    menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    menuPanel.setAttribute('aria-hidden', open ? 'false' : 'true');
    body.classList.toggle('is-menu-open', open);
  }

  if (menuToggle) {
    menuToggle.addEventListener('click', function () {
      setMenu(menuToggle.getAttribute('aria-expanded') !== 'true');
    });
  }

  if (menuClose) {
    menuClose.addEventListener('click', function () {
      setMenu(false);
    });
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') setMenu(false);
  });

  var header = document.querySelector('[data-site-header]');
  function updateHeader() {
    if (!header) return;
    header.classList.toggle('is-scrolled', window.scrollY > 16);
  }
  updateHeader();
  window.addEventListener('scroll', updateHeader, { passive: true });

  var revealItems = Array.prototype.slice.call(document.querySelectorAll('[data-reveal]'));
  if ('IntersectionObserver' in window && revealItems.length) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    revealItems.forEach(function (item) {
      observer.observe(item);
    });
  } else {
    revealItems.forEach(function (item) {
      item.classList.add('is-visible');
    });
  }

  document.addEventListener('shopify:section:load', function () {
    revealItems = Array.prototype.slice.call(document.querySelectorAll('[data-reveal]'));
    revealItems.forEach(function (item) {
      item.classList.add('is-visible');
    });
  });

  Array.prototype.slice.call(document.querySelectorAll('[data-variant-select]')).forEach(function (select) {
    select.addEventListener('change', function () {
      var option = select.options[select.selectedIndex];
      var container = select.closest('.fw-product-template__content');
      var price = container ? container.querySelector('[data-product-price]') : null;
      if (!price || !option) return;
      var current = option.getAttribute('data-price');
      var compare = option.getAttribute('data-compare-price');
      var saving = option.getAttribute('data-saving-price');
      var available = option.getAttribute('data-available') !== 'false';
      price.innerHTML = '<span>' + current + '</span>' + (compare ? '<s>' + compare + '</s>' : '');

      var savingTarget = container.querySelector('[data-product-saving]');
      if (savingTarget) {
        savingTarget.hidden = !saving;
        var savingValue = savingTarget.querySelector('span');
        if (savingValue) savingValue.textContent = saving || '';
      }

      Array.prototype.slice.call(document.querySelectorAll('[data-product-sticky-price]')).forEach(function (target) {
        target.textContent = current;
      });

      var submitButton = container ? container.querySelector('[data-product-submit]') : null;
      if (submitButton) {
        submitButton.disabled = !available;
        submitButton.textContent = available ? 'Agregar al carrito' : 'Agotado';
      }

      Array.prototype.slice.call(document.querySelectorAll('[data-product-sticky-submit]')).forEach(function (button) {
        button.disabled = !available;
        button.textContent = available ? 'Agregar' : 'Agotado';
      });
    });
  });
})();
